<template>
  <base-modal hide-footer hide-header close="$emit('close')">
      <div class="col-sm-12 form-data">
        <h3 class="editor-header">{{ $t('map.select_editable_layer') }}</h3>
        <ul class="suggestions-list">
          <li
            v-for="item in options"
            :key="item"
            @click="$emit('onSelectionSelected', item)"
          >
            {{ mapItemText(item) }}
          </li>
        </ul>
        <div class="col-sm-12 button-container">
          <button class="btn btn-primary form-button" @click.stop="$emit('close')">
            {{ $t('common.back') }}
          </button>
        </div>
      </div>
  </base-modal>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import BaseModal from "@/components/BaseModal";

export default {
    name: "MapSelectionEditor",
    components: {BaseModal},
    mixins: [mapHelper],
    props: {
        options: {
            type: Array,
        },
    },
    methods: {
        mapItemText(item) {
            switch (item) {
                case this.OBSERVATION: return this.$t('menu.observations')
                case this.WORK_ASSIGNMENT: return this.$t('map_tooltips.work_assignments')
                case this.TRAFFIC_SIGN: return this.$t('map_tooltips.traffic_signs')
                case this.STREET_LIGHT: return this.$t('menu.street_lights')
                case this.SEWERS: return this.$t('storm_sewers.sewers')
                case this.DRAINS: return this.$t('storm_sewers.drains')
                case this.MIXED_WASTE_BINS: return this.$t('map.add_mixed_waste_bin')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
ul.suggestions-list {
    list-style: none;
    padding: 0;
    margin: 1rem 0 0 0;
    max-height: 400px;
    overflow: auto;

    li {
        padding: 1em 0.5em;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        Transition: background-color 0.25s ease-out;
        cursor: pointer;

    &:last-child {
         border-bottom: none;
     }
    &:only-child {
         border-top: 1px solid rgba(0, 0, 0, 0.1);
         border-bottom: 1px solid rgba(0, 0, 0, 0.1);
     }
    &:hover {
         background-color: rgba(0, 0, 0, 0.1);
     }
    }
}
</style>
